import { UcoastEl } from '@/scripts/core/UcoastEl'
import { revealMotionEnabled } from '@/scripts/core/motion'

export class ClinicalResults extends UcoastEl {
	static htmlSelector = 'clinical-results'

	private percentages: NodeListOf<HTMLElement>
	private hasStarted = false
	private animationFrame: number | null = null

	constructor() {
		super()

		this.percentages = this.querySelectorAll<HTMLElement>(
			'[data-percentage]'
		)

		this.setupIntersectionObserver()
	}

	private setupIntersectionObserver(): void {
		const observer = new IntersectionObserver(
			(entries) => {
				const entry = entries[0]

				if (!entry.isIntersecting || this.hasStarted) {
					return
				}

				this.hasStarted = true
				this.animatePercentages()

				observer.disconnect()
			},
			{
				threshold: 0.25,
			}
		)

		observer.observe(this)
	}

	private animatePercentages(): void {
		if (!revealMotionEnabled()) {
			this.percentages.forEach((percentage) => {
				percentage.textContent = percentage.dataset.percentage ?? '0'
			})
			return
		}

		const duration = 1500
		const startTime = performance.now()

		const update = (currentTime: number): void => {
			const elapsed = currentTime - startTime
			const progress = Math.min(elapsed / duration, 1)

			// Ease out
			const easedProgress = 1 - Math.pow(1 - progress, 3)

			this.percentages.forEach((percentage) => {
				const target = Number(
					percentage.dataset.percentage ?? 0
				)

				const value = Math.round(target * easedProgress)

				percentage.textContent = String(value)
			})

			if (progress < 1) {
				this.animationFrame = requestAnimationFrame(update)
			} else {
				this.animationFrame = null
			}
		}

		this.animationFrame = requestAnimationFrame(update)
	}

	override disconnectedCallback(): void {
		if (this.animationFrame !== null) {
			cancelAnimationFrame(this.animationFrame)
		}
	}
}
